import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import _ from 'lodash'

import { PagesBanner } from '../'
import './ResourceGlossary.sass'


const alphabet = 'abcdefghijklmnopqrstuvwxyz'.split('')

class ResourceGlossary extends Component {
  state = {
    activeLetter: 'a'
  }

  constructor(props) {
    super(props)
    this.helmet = (
      <Helmet>
        <title>{this.props.contentData.title} | Gulf TREE</title>
      </Helmet>
    )
  }

  renderAlphabet() {
    return alphabet.map(letter =>
      <button
        key={letter}
        aria-label="select letter"
        className={letter === this.state.activeLetter ? 'active' : ''}
        onClick={() => this.setState({ activeLetter: letter })}
      >
        {letter}
      </button>
    )
  }

  renderSelectedList() {
    const allTerms = _.flatMap(this.props.contentData.glossary_terms, termsByLetter => termsByLetter.terms)
    const selectedTerms = allTerms.filter(termData => termData.term.toLowerCase().startsWith(this.state.activeLetter))
    const sortedTerms = _.sortBy(selectedTerms, 'term')

    if (sortedTerms.length <= 0) {
      return <div>No terms for selected letter</div>
    }

    return sortedTerms.map((termData, idx) =>
      <div key={idx} className="glossary-term">
        <div className="glossary-term-name">{termData.term}</div>
        <p className="glossary-term-definition">{termData.definition}</p>
      </div>
    )
  }

  render() {
    return (
      <div className="page__wrapper glossary-container">
        {this.helmet}
        <PagesBanner bgClassName={this.props.bgClassName} title={this.props.contentData.title} />
        <section className="page__content">
          <nav>{this.renderAlphabet()}</nav>
          <div className="glossary-terms">{this.renderSelectedList()}</div>
        </section>
      </div>
    )
  }
}

ResourceGlossary.propTypes = {
  contentData: PropTypes.shape({
    glossary_terms: PropTypes.array,
    title: PropTypes.string
  }),
  bgClassName: PropTypes.string
}

export default ResourceGlossary
